import { Component, Input, OnInit, AfterViewChecked } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-generic-select-modal',
  templateUrl: './generic-select-modal.component.html'
})
export class GenericSelectModalComponent implements OnInit, AfterViewChecked {

  @Input() modalTitle: string;
  @Input() modalDescription: string;
  @Input() okButton: string;
  @Input() cancelButton: string;

  private _listOfItems: any[];
  modalSelect: string;
  selectedItem: Subject<string>;

  constructor(
    public bsModalRef: BsModalRef
  ) { }

  @Input() set listOfItems(list: any[]) {
    this._listOfItems = list;
  }

  ngOnInit() {
    this.selectedItem = new Subject();
  }

  ngAfterViewChecked() {
    document.getElementById('modalSelect').focus();
  }

  onCloseOrCancel() {
    this.selectedItem.next(null);
    this.bsModalRef.hide();
  }

  onOK() {
    this.selectedItem.next(this.modalSelect);
    this.bsModalRef.hide();
  }

}
